let jobs = [];
let colReverse = [];

function getJobs() {
  loadingJobs();
  fetch(
    `https://recruiting.paylocity.com/recruiting/v2/api/feed/jobs/474804db-ad7a-45eb-a799-4bf7353064eb`
  )
    .then((res) => res.json())
    .then((resJSON) => {
      jobs = resJSON["jobs"].map((job) => {
        return {
          title: job["title"],
          description: job["description"],
          department: job["hiringDepartment"] || "General",
          location: job["jobLocation"]["locationDisplayName"] || "",
          applyUrl: job["applyUrl"],
        };
      });
      removeLoader();
      buildJobsTable(jobs);
      buildFilterButtons(jobs, "department");
      buildFilterButtons(jobs, "location");
    })
    .catch((err) => {
      removeLoader();
      failedFetch();
    });
}

function buildJobsTable(jobsArray) {
  // let jobsLocations = [...new Set(jobsArray.map(job => job['location']))].sort();
  let jobsGrid = document.getElementById("jobs-grid");

  // Remove spaces created by formatting
  jobsGrid.textContent = "";
  jobsArray.forEach((job, index) => {
    let newDiv = document.createElement("div");
    const locationClass =
      "location-" +
      job["location"].replace("-", "").replace(/\s+/g, "-").toLowerCase();
    const departmentClass =
      "department-" +
      job["department"].replace("-", "").replace(/\s+/g, "-").toLowerCase();
    newDiv.classList.add("job-row", locationClass, departmentClass);
    let row = jobsGrid.appendChild(newDiv);
    const jobID = `job-${index}`;

    // Parse the job description HTML
    const jobDescriptionHTML = rtrim(job["description"]);
    const parser = new DOMParser();
    const jobDescriptionDoc = parser.parseFromString(
      jobDescriptionHTML,
      "text/html"
    );

    const jobRowHeadingDiv = document.createElement("div");
    jobRowHeadingDiv.classList.add("job-row-heading");

    const jobTitleDiv = document.createElement("div");
    jobTitleDiv.classList.add("job-title");

    const jobTitleButton = document.createElement("button");
    jobTitleButton.setAttribute("type", "button");
    jobTitleButton.setAttribute("aria-expanded", "false");
    jobTitleButton.classList.add("nolink");
    jobTitleButton.setAttribute("data-target", jobID);
    jobTitleButton.setAttribute("aria-controls", jobID);

    const emptySpan = document.createElement("span");
    jobTitleButton.textContent = job["title"];
    jobTitleButton.prepend(emptySpan);

    const jobDepartmentDiv = document.createElement("div");
    jobDepartmentDiv.classList.add("job-department");
    jobDepartmentDiv.textContent = job["department"];

    const jobLocationDiv = document.createElement("div");
    jobLocationDiv.classList.add("job-location");
    jobLocationDiv.textContent = job["location"];

    const jobUrlDiv = document.createElement("div");
    jobUrlDiv.classList.add("job-url");

    const applyButton = document.createElement("a");
    applyButton.classList.add("button", "apply-button");
    applyButton.setAttribute("href", job["applyUrl"]);
    applyButton.setAttribute("target", "_blank");
    applyButton.setAttribute("rel", "noopener");
    applyButton.textContent = Drupal.t("Apply now");

    jobUrlDiv.appendChild(applyButton);

    const jobDescriptionDiv = document.createElement("div");
    jobDescriptionDiv.setAttribute("id", jobID);
    jobDescriptionDiv.classList.add("hidden", "job-description");
    jobDescriptionDiv.replaceChildren(...jobDescriptionDoc.body.childNodes);

    jobRowHeadingDiv.appendChild(jobTitleDiv);
    jobTitleDiv.appendChild(jobTitleButton);
    jobRowHeadingDiv.appendChild(jobDepartmentDiv);
    jobRowHeadingDiv.appendChild(jobLocationDiv);
    jobRowHeadingDiv.appendChild(jobUrlDiv);

    row.appendChild(jobRowHeadingDiv);
    row.appendChild(jobDescriptionDiv);

    rowReveal(jobID);
  });
}

function sortJobs(column) {
  let columnHeadings = document.querySelector("#jobs-grid-heading").children;
  let thisColumnHeading = document.getElementById(column + "-column");

  let sortButtons = document.getElementsByClassName("sort-button");
  let thisButton = document.getElementById("sort-" + column);

  let jobsGrid = document.getElementById("jobs-grid");

  jobs.sort(function (a, b) {
    return a[column].localeCompare(b[column]);
  });

  if (!colReverse[column]) {
    colReverse = [];
    colReverse[column] = "ascending";
  } else {
    if (colReverse[column] === "ascending") {
      jobs.reverse();
      colReverse[column] = "descending";
    } else {
      colReverse[column] = "ascending";
    }
  }

  Array.prototype.forEach.call(columnHeadings, (heading) =>
    heading.removeAttribute("aria-sort")
  );
  Array.prototype.forEach.call(sortButtons, (button) =>
    button.removeAttribute("aria-pressed")
  );

  thisButton.setAttribute("aria-pressed", "true");
  thisColumnHeading.setAttribute("aria-sort", colReverse[column]);

  jobsGrid.textContent = "";
  buildJobsTable(jobs);
}

function buildFilterButtons(jobsArray, categoryName) {
  const categoriesArray = [
    ...new Set(jobsArray.map((job) => job[categoryName])),
  ].sort();
  const filtersContainer = document.getElementById("jobs-filters");
  const clearFiltersContainer = document.getElementById(
    "clear-filter-buttons-container"
  );
  const dropDownContainer = document.createElement("div");

  const listContainer = document.createElement("div");
  listContainer.classList.add("filter-list-container");
  listContainer.id = `${categoryName}-filters`;
  listContainer.classList.add("hidden");

  const filtersList = document.createElement("ul");
  filtersList.classList.add("filters-list");

  const dropDownButton = document.createElement("button");
  dropDownButton.id = `${categoryName}-filter-button`;
  dropDownButton.classList.add("filter-list-reveal");
  dropDownButton.setAttribute("type", "button");
  dropDownButton.setAttribute("aria-expanded", "false");
  dropDownButton.setAttribute("data-toggle", "reveal");
  dropDownButton.setAttribute("aria-controls", categoryName + "-filters");
  dropDownButton.setAttribute(
    "aria-label",
    Drupal.t("Filter by @category", { "@category": categoryName })
  );
  dropDownButton.setAttribute("data-target", categoryName + "-filters");

  const filterSpan = document.createElement("span");
  const collapseArrowSpan = document.createElement("span");
  collapseArrowSpan.classList.add("collapse-arrow");
  filterSpan.textContent = Drupal.t("Filter by @category", {
    "@category": categoryName,
  });
  dropDownButton.appendChild(filterSpan);
  dropDownButton.appendChild(collapseArrowSpan);

  const closeDropDownButton = document.createElement("button");
  closeDropDownButton.classList.add("filter-list-close");
  closeDropDownButton.setAttribute("type", "button");
  closeDropDownButton.setAttribute("aria-label", Drupal.t("Close filter list"));
  closeDropDownButton.textContent = "X";
  closeDropDownButton.onclick = function () {
    filterListClose(this, categoryName);
  };

  categoriesArray.forEach((category, index) => {
    const categoryClass = `${categoryName}-${category.replace("-", "").replace(/\s+/g, "-").toLowerCase()}`;
    let newLi = document.createElement("li");
    let newButton = document.createElement("button");
    newButton.id = `filter-${categoryClass}`;
    newButton.classList.add("filter-button");
    // newButton.setAttribute('id', `filter-${category}`);
    newButton.setAttribute("data-filter", categoryClass);
    newButton.setAttribute("aria-pressed", "false");
    newButton.setAttribute("type", "button");
    newButton.textContent = Drupal.t(category);
    filtersList.appendChild(newLi).appendChild(newButton);
    newButton.onclick = function () {
      filterJobs(this);
    };
  });

  filtersContainer.insertBefore(dropDownContainer, clearFiltersContainer);
  dropDownContainer.appendChild(dropDownButton);
  dropDownContainer.appendChild(listContainer);
  listContainer.appendChild(closeDropDownButton);
  listContainer.appendChild(filtersList);
  filterListReveal(categoryName + "-filters");
}

function filterJobs(button) {
  (function (Drupal, $) {
    const jobRows = Array.from(document.getElementsByClassName("job-row"));
    const filterListContainers = Array.from(
      document.getElementsByClassName("filter-list-container")
    ).map((list) => ({
      id: list.getAttribute("id"),
    }));

    button.setAttribute(
      "aria-pressed",
      button.getAttribute("aria-pressed") === "true" ? "false" : "true"
    );

    const selectedCatArrays = filterListContainers
      .map((container) => ({
        id: container.id,
        selectedFilters: Array.from(
          document.querySelectorAll("#" + container.id + " .filter-button")
        )
          .filter((button) => button.getAttribute("aria-pressed") === "true")
          .map((button) => button.getAttribute("data-filter")),
      }))
      .filter((container) => container.selectedFilters.length > 0); // Filter out containers with no selected filters

    if (selectedCatArrays.length === 0) {
      // If no buttons are pressed, show all rows
      jobRows.forEach((row) => {
        if ($(row).parent().is(".hidden-wrapper")) {
          $(row).unwrap();
        }
      });
    } else if (selectedCatArrays.length === 1) {
      const selectedCategories = selectedCatArrays[0].selectedFilters;

      jobRows.forEach((row) => {
        const isMatch = selectedCategories.some((cat) =>
          row.classList.contains(cat)
        );
        if (isMatch) {
          if ($(row).parent().is(".hidden-wrapper")) {
            $(row).unwrap();
          }
        } else {
          // wrap in hidden element to preserve odd/even row styling for visible divs
          if (!$(row).parent().is(".hidden-wrapper")) {
            $(row).wrap('<hidden class="hidden hidden-wrapper"></hidden>');
          }
        }
      });
    } else {
      // Generate combinations of values from each array
      const combinations = selectedCatArrays.reduce((acc, container) => {
        const array = container.selectedFilters;
        if (acc.length === 0) return array.map((value) => [value]);
        return acc.flatMap((comb) => array.map((value) => [...comb, value]));
      }, []);
      jobRows.forEach((row) => {
        const isMatch = combinations.some((comb) =>
          comb.every((cat) => row.classList.contains(cat))
        );
        if (isMatch) {
          if ($(row).parent().is(".hidden-wrapper")) {
            $(row).unwrap();
          }
        } else {
          if (!$(row).parent().is(".hidden-wrapper")) {
            $(row).wrap('<hidden class="hidden hidden-wrapper"></hidden>');
          }
        }
      });
    }

    // Create a new array of objects containing the button id and text
    const selectedCategoriesInfo = selectedCatArrays.flatMap((container) =>
      container.selectedFilters.map((filter) => ({
        id: filter,
        text: document
          .querySelector(`[data-filter="${filter}"]`)
          .textContent.trim(),
      }))
    );

    // Call buildClearFiltersButtons with the new array
    buildClearFiltersButtons(selectedCategoriesInfo);
  })(Drupal, jQuery);
}

function buildClearFiltersButtons(categoriesArray) {
  const clearFiltersContainer = document.getElementById(
    "clear-filter-buttons-container"
  );
  const existingButtons = Array.from(
    clearFiltersContainer.getElementsByClassName("clear-filter-button")
  );

  // Remove buttons for categories that are no longer selected
  existingButtons.forEach((button) => {
    const buttonText = button.textContent.replace(" <span></span>", "").trim();
    const isSelected = categoriesArray.some(
      (category) => category.text === buttonText
    );
    if (!isSelected) {
      clearFiltersContainer.removeChild(button);
    }
  });

  categoriesArray.forEach((category) => {
    // Check if a button with the same text already exists
    const existingButton = existingButtons.find((button) =>
      button.textContent.includes(category.text)
    );

    if (!existingButton) {
      const clearButton = document.createElement("button");
      clearButton.id = `clear-${category.id}`;
      clearButton.classList.add("clear-filter-button");
      clearButton.setAttribute("type", "button");
      clearButton.setAttribute(
        "aria-label",
        Drupal.t("Clear filter: @filter", { "@filter": category.text })
      );

      const emptySpan = document.createElement("span");

      clearButton.textContent = Drupal.t(category.text);
      clearButton.appendChild(emptySpan);
      clearButton.onclick = function () {
        clearFilter(category.id);
      };
      clearFiltersContainer.appendChild(clearButton);
    }
  });
}

function clearFilter(category) {
  const filterButtonToClear = document.getElementById(`filter-${category}`);
  const thisButton = document.getElementById(`clear-${category}`);

  thisButton.remove();
  filterJobs(filterButtonToClear);
}

/* trim the job description to remove the job title and first empty <p> tag. */
function rtrim(str) {
  if (!str) return str;
  return str.replace(/^<p>.*?<\/p>/g, "").replace(/^<p><br[\/]?><[\/]?p>/g, "");
}

function filterListReveal(id) {
  const revealButton = document.body.querySelector(
    `button[data-target="${id}"]`
  );
  const targetEl = document.getElementById(id);
  revealButton.onclick = function () {
    const buttonExpanded = revealButton.getAttribute("aria-expanded");
    buttonExpanded === "false"
      ? revealButton.setAttribute("aria-expanded", "true")
      : revealButton.setAttribute("aria-expanded", "false");
    targetEl.classList.toggle("hidden");
    Array.from(
      document.querySelectorAll(`.filter-list-container:not(#${id}`)
    ).forEach((list) => list.classList.add("hidden"));
    Array.from(
      document.querySelectorAll(`.filter-list-reveal:not(#${this.id})`)
    ).forEach((button) => button.setAttribute("aria-expanded", "false"));
  };
}

function filterListClose(button, category) {
  document
    .getElementById(`${category}-filter-button`)
    .setAttribute("aria-expanded", "false");
  button.closest(".filter-list-container").classList.add("hidden");
}

function rowReveal(id) {
  const revealButton = document.body.querySelector(
    `button[data-target="${id}"]`
  );
  const parentRow = revealButton.closest(".job-row");
  const targetDiv = document.getElementById(id);
  revealButton.onclick = function () {
    const buttonExpanded = revealButton.getAttribute("aria-expanded");
    buttonExpanded === "false"
      ? revealButton.setAttribute("aria-expanded", "true")
      : revealButton.setAttribute("aria-expanded", "false");
    targetDiv.classList.toggle("hidden");
    parentRow.classList.toggle("active-job");
  };
}

function loadingJobs() {
  let jobsGrid = document.getElementById("jobs-grid");
  const loaderDiv = document.createElement("div");
  loaderDiv.id = "loading-jobs";

  const loadingSpan = document.createElement("span");
  loadingSpan.textContent = Drupal.t("Loading jobs...");

  const loaderSpan = document.createElement("span");
  loaderSpan.classList.add("loader");
  loaderDiv.appendChild(loadingSpan);
  loaderDiv.appendChild(loaderSpan);
  jobsGrid.appendChild(loaderDiv);
}

function removeLoader() {
  const loader = document.getElementById("loading-jobs");
  loader.remove();
}

function failedFetch() {
  let jobsGrid = document.getElementById("jobs-grid");
  const errorParagraph = document.createElement("p");
  errorParagraph.id = "jobs-error";
  errorParagraph.textContent = Drupal.t(
    "Looks like we're having trouble connecting to the jobs listing. Please try refreshing the page."
  );
  jobsGrid.appendChild(errorParagraph);
}

(function ($, Drupal, once) {
  Drupal.behaviors.getJobs = {
    attach: function (context, settings) {
      once("getJobs", "body").forEach(function () {
        getJobs();
      });
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          Array.from(
            document.querySelectorAll(".filter-list-container")
          ).forEach((filterList) => filterList.classList.add("hidden"));
          Array.from(document.querySelectorAll(".filter-list-reveal")).forEach(
            (button) => button.setAttribute("aria-expanded", "false")
          );
        }
      });
    },
  };
})(jQuery, Drupal, once);
